import type { FieldValue } from "@/shared/types/workflow/workflow-form.types";
import type { RichText } from "@spz/shared-domain";

/**
 * Returns the default value for a textarea field
 */
export function getTextAreaDefaultValue(): FieldValue {
  return {
    content: [],
    type: "doc",
  } as RichText;
}
